export const CURRENCY_CONVERSION_CAP = 'admin_panel_currency_conversion';

export const CURRENCY_CODES = ['GBP', 'EUR', 'USD', 'CHF'] as const;

export type CurrencyCode = (typeof CURRENCY_CODES)[number];

export interface CreditPricingTierRow {
  id: number;
  currency_code: CurrencyCode | string;
  min_credits: number;
  max_credits: number;
  discount_percent: string;
  cost_per_credit: string;
  display_order: number;
}
